export default __webpack_public_path__ + "static/media/loading_logo_color.34ba9a19.gif";